var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"context__menu-item-link",class:{
    'context__menu-item-link--loading': _vm.duplicating,
    disabled: _vm.disabled || _vm.duplicating,
  },on:{"click":function($event){return _vm.duplicateTable()}}},[_c('i',{staticClass:"context__menu-item-icon iconoir-copy"}),_vm._v("\n  "+_vm._s(_vm.$t('action.duplicate'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }